module.exports = __webpack_public_path__ + "img/DSC_1044-Edit-2.9a7991b7.9a7991b7.jpg";